import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref } from "firebase/storage";

let config = {
    apiKey: "AIzaSyBFWGvDmGLnGHFxT8tgDYXBzMAoZDU_vv8",
    authDomain: "bondedworld-f9e37.firebaseapp.com",
    databaseURL: "https://bondedworld-f9e37.firebaseio.com",
    projectId: "bondedworld-f9e37",
    storageBucket: "bondedworld-f9e37.appspot.com",
    messagingSenderId: "459441108714",
    appId: "1:459441108714:web:3bf235b63f75d9c88e0993",
    measurementId: "G-FFSH2C2VVH"
};

class Firebase {
    constructor() {
        this.firebase = initializeApp(config);
    }

    getAppStorage(path) {
        return ref(getStorage(this.firebase), path);
    }

    getAppFirestore() {
        return getFirestore(this.firebase);
    }
}

export default Firebase;
